const React = require('react');
const { default: Styled } = require('styled-components');
const { useFieldContext } = require('./FieldContext');
const GroupComponents = require('./groupComponents');

const internals = {};

// Resolve styled group modules before ManagedFieldsRenderer begins rendering so
// module initialization cannot alter this component's React hook order.
GroupComponents.preloadComponents();

module.exports = function ManagedFieldsRenderer(props) {

    const {
        fieldsWrapper: FieldsWrapper = React.Fragment,
        groupComponents,
        groupComponentRegistry
    } = props || {};

    const fieldContext = useFieldContext();
    const groups = fieldContext?.formConfig?.groups || [];

    const { GroupSeparator } = internals;

    const fields = groups.flatMap((group, index) => {

        const GroupComponent = GroupComponents.resolveGroupComponent({
            type: group.type,
            component: group.component,
            components: groupComponents,
            registry: groupComponentRegistry
        });

        if (!GroupComponent) {
            return [];
        }

        const groupNode = <GroupComponent
            key={group.name}
            {...group.componentProps}
        />;

        if (index === groups.length - 1) {
            return [groupNode];
        }

        return [
            groupNode,
            index === 0 ? null : <GroupSeparator key={`${group.name}--separator`} />
        ];
    });

    return <FieldsWrapper>
        {fields}
    </FieldsWrapper>;
};

internals.GroupSeparator = Styled.div`
    width: 100%;
    margin: 50px 0;
    padding-left: ${({ theme }) => theme.spacing(2)};
    padding-right: ${({ theme }) => theme.spacing(2)};
    margin-top: ${({ theme }) => theme.spacing(3)};
    margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

module.exports.internals = internals;
